import type { LevelConfig } from '../index';

export const level6: LevelConfig = {
  id: 'level_6',
  stage: '2',
  mapId: 'map_06',
  timeLimitSec: 160,
  playerSpawn: { x: 160, y: 160 },
  objective: { type: 'collect_coins', target: 3 },
  secondaryObjective: { type: 'find_key', target: 1 },
  enemies: [
    { type: 'BASIC_SCAMMER', position: { x: 400, y: 300 }, patrolPath: [{ x: 400, y: 300 }, { x: 400, y: 500 }, { x: 250, y: 500 }, { x: 250, y: 300 }] },
    { type: 'BASIC_SCAMMER', position: { x: 700, y: 400 }, patrolPath: [{ x: 700, y: 400 }, { x: 700, y: 600 }, { x: 550, y: 600 }, { x: 550, y: 400 }] },
    { type: 'BASIC_SCAMMER', position: { x: 300, y: 700 }, patrolPath: [{ x: 300, y: 700 }, { x: 500, y: 700 }, { x: 500, y: 800 }, { x: 300, y: 800 }] },
    { type: 'ARMORED_SCAMMER', position: { x: 600, y: 300 }, patrolPath: [{ x: 600, y: 300 }, { x: 600, y: 500 }] },
    { type: 'ARMORED_SCAMMER', position: { x: 800, y: 700 }, patrolPath: [{ x: 800, y: 700 }, { x: 800, y: 850 }, { x: 650, y: 850 }] },
  ],
  loot: [
    ...Array.from({ length: 15 }, (_, i) => ({
      type: 'COIN' as const,
      position: { x: 200 + (i % 5) * 150, y: 250 + Math.floor(i / 5) * 150 },
      value: 10,
    })),
    { type: 'QUEST_ITEM', position: { x: 800, y: 200 }, value: 1 },
  ],
  startingWeapon: 'RIFLE',
  startingAmmo: 4,
  unlocks: [],
  challenge: {
    type: 'stealth',
    description: 'Пройди без выстрела',
    reward: { type: 'boost', amount: 1 },
  },
};
